<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4587"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4591"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4601"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4599" /></clipPath></defs><g
     id="g4593"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4595"><g
         id="g4597"
         clip-path="url(#clipPath4601)"><g
           id="g4603"
           transform="translate(356.0889,7.5)"><path
             d="m 0,0 h -200.178 c -5.402,0 -9.78,4.379 -9.78,9.781 0,20.437 16.567,37.005 37.004,37.005 h 145.73 C -6.787,46.786 9.781,30.218 9.781,9.781 9.781,4.379 5.401,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4605" /></g><g
           id="g4607"
           transform="translate(480.2588,160.2842)"><path
             d="M 0,0 H -448.518"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4609" /></g><g
           id="g4611"
           transform="translate(210.1206,456.792)"><path
             d="M 0,0 H -57.287"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4613" /></g><g
           id="g4615"
           transform="translate(480.2588,406.6289)"><path
             d="M 0,0 V 21.904 C 0,37.512 -12.652,50.163 -28.259,50.163 H -229.974"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4617" /></g><g
           id="g4619"
           transform="translate(135.918,456.792)"><path
             d="m 0,0 h -75.917 c -15.607,0 -28.26,-12.651 -28.26,-28.259 v -293.423 c 0,-15.607 12.653,-28.259 28.26,-28.259 h 391.999 c 15.606,0 28.259,12.652 28.259,28.259 v 235.797"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4621" /></g><g
           id="g4623"
           transform="translate(337.7881,261.5645)"><path
             d="m 0,0 15.929,-15.93 c 11.095,-11.095 29.085,-11.095 40.18,0 v 10e-4 c 11.096,11.095 11.096,29.085 0,40.18 L 39.22,41.141"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4625" /></g><g
           id="g4627"
           transform="translate(286.1025,393.6104)"><path
             d="m 0,0 -16.618,16.619 c -10.145,10.144 -16.612,23.417 -18.191,37.676 -0.072,0.656 -0.123,1.218 -0.148,1.662 -0.77,13.737 -6.401,27.254 -16.897,37.749 -14.545,14.546 -35.116,19.973 -53.815,15.838 -5.015,-1.108 -6.79,-7.358 -3.159,-10.989 L -80.743,70.47 c 8.259,-8.259 8.259,-21.649 0,-29.907 -8.258,-8.258 -21.649,-8.258 -29.907,0 l -28.085,28.084 c -3.631,3.632 -9.881,1.856 -10.99,-3.158 -4.134,-18.699 1.293,-39.27 15.839,-53.816 10.495,-10.495 24.011,-16.126 37.748,-16.896 0.445,-0.025 1.006,-0.076 1.663,-0.149 13.702,-1.516 26.492,-7.548 36.472,-17.018 v 0.001 l 0.025,-0.025"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4629" /></g><g
           id="g4631"
           transform="translate(174.4863,290.9551)"><path
             d="m 0,0 v 0 c -5.907,-5.907 -5.907,-15.484 0,-21.392 l 75.263,-75.262 c 5.907,-5.908 15.484,-5.908 21.391,0 5.908,5.907 5.908,15.484 0,21.391 L 21.392,0 C 15.485,5.907 5.907,5.907 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4633" /></g><g
           id="g4635"
           transform="translate(269.8896,216.9434)"><path
             d="m 0,0 17.535,17.535 c 2.558,2.559 5.579,4.607 8.903,6.037 l 23.297,10.023 c 11.813,5.806 22.59,13.518 31.897,22.826 l 20.925,20.596 c 6.606,6.605 6.414,17.435 -0.575,23.796 -3.594,3.27 -8.288,4.571 -12.826,4.043 -0.658,-0.077 -1.317,0.127 -1.779,0.603 l -0.122,0.127 c -0.725,0.746 -0.781,1.918 -0.125,2.726 0.786,0.968 1.751,2.222 2.163,3.022 3.055,5.929 2.252,13.389 -2.675,18.327 -5.406,5.42 -12.934,6.771 -19.119,3.892 -0.235,-0.11 -0.76,-0.27 -0.972,-0.014 -0.221,0.266 0.02,0.731 0.163,0.931 4.516,6.324 4.316,15.164 -1.133,20.989 -5.082,5.434 -12.919,6.645 -19.191,3.572 -0.072,-0.035 -0.579,-0.288 -0.753,-0.077 -0.275,0.335 0.188,0.792 0.188,0.792 l 1.656,1.656 c 6.262,6.262 6.843,16.465 0.881,23.014 -6.359,6.987 -17.211,7.151 -23.816,0.547 L -15.466,145.04 c -0.306,-0.308 -0.625,-0.59 -0.953,-0.851 l -0.203,-0.202 c -4.308,-4.308 -10.665,-4.184 -14.972,0.126 l -10.196,10.165 c -9.32,-9.865 -14.81,-22.968 -13.206,-36.465 l 1.698,-14.276 c 1.033,-8.688 -1.975,-17.37 -8.161,-23.557 l -9.261,-9.259"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4637" /></g><g
           id="g4639"
           transform="translate(115.5898,210.7129)"><path
             d="M 0,0 -50.429,-50.429"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4641" /></g><g
           id="g4643"
           transform="translate(174.4863,269.5635)"><path
             d="M 0,0 C -0.007,0.008 -0.015,0.016 -0.022,0.023 L -33.733,-33.688"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4645" /></g><g
           id="g4647"
           transform="translate(221.8184,160.2842)"><path
             d="M 0,0 31.413,31.413"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4649" /></g><g
           id="g4651"
           transform="translate(219.4199,106.8506)"><path
             d="M 0,0 -13.644,-52.564"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4653" /></g><g
           id="g4655"
           transform="translate(306.2236,54.2861)"><path
             d="M 0,0 -13.644,52.564"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4657" /></g></g></g></g></svg>
</template>
